export { default } from './ListItemText';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemText/index.js
// module id = 491
// module chunks = 13